import Dexie from "dexie";

export const db = new Dexie("artemis");

// Non-null when the IndexedDB database failed to open (corruption after a
// crash, a version rollback, etc.). Readers can distinguish "no local data"
// from "local data unreadable" — the latter must never render as an empty
// state, or users assume their offline work is gone.
export let dbOpenError = null;

export function initIndexDB() {
  db.version(48).stores({
    sanitationRoutes: `
      ++id,
      active,
      status,
      farm_id,
      lot_id,
      lot_name,
      sanitation_monitor_id,
      sanitation_monitor_name,
      sanitation_form_id,
      sanitation_form_name,
      route_question_id,
      tree_question_id,
      tree_sample_question_id,
      number_of_tree_sections,
      samples_per_tree_section,
      has_route_question,
      has_tree_questions,
      has_tree_sample_questions,
      current_question_type,
      current_section_number,
      current_sample_number,
      current_tree_number,
      total_trees_in_route,
      completed_at,
      created_at`,
    sanitationForms: `
      id,
      farm_id,
      open_ended,
      open_ended_samples,
      name,
      description,
      lot_tree_percentage,
      updated_at`,
    routeDatapoints: `
      ++id,
      data,
      tree_number,
      question_type,
      sanitation_route_id,
      created_at`,
    routeLocations: `
      ++id,
      lat,
      lon,
      sanitation_route_id,
      created_at`,
    fileQueue: `
      ++id,
      sanitation_route_id,
      route_datapoint_id,
      custom_field_id,
      tree_number,
      question_type,
      file_local_id,
      file_name,
      file_size,
      file_type,
      local_path,
      upload_status,
      upload_progress,
      error_message,
      created_at,
      uploaded_at`,
    fileBlobs: `
      file_id,
      blob,
      file_name,
      file_size,
      file_type,
      created_at,
      last_accessed`,
    harvestEntryQueue: `
      ++id,
      farm_id,
      status,
      created_at`,
  });

  db.open().catch(async (error) => {
    dbOpenError = error;
    // DebugLogger is imported lazily: it must not become a hard dependency of
    // the DB module (it also runs in tests without a DOM).
    try {
      const { DebugLogger } = await import("./debugLogger.js");
      DebugLogger.error("IndexedDB open failed", {
        name: error?.name,
        message: error?.message,
      });
    } catch {
      console.error("IndexedDB open failed", error);
    }
  });

  window.db = db;
}
